<template>
  <question-group headline="Rate Peers">
    <section>
      <transition-group name="list" tag="div">
        <rate-peer :review="vm.activeReview" @submit="vm.savePeerReview" v-for="review in blast.reviews" v-if="vm.activeReview && review.id == vm.activeReview.id" class="peer-review" :key="review.id" />
        <div v-if="!vm.activeReview" key="empty" class="peer-review"><p>{{ noReviewsAvailableMessage }}</p></div>
      </transition-group>
    </section>
  </question-group>
</template>

<script>

  import sidebar from "./sidebar"

  export default {
    name: 'rate',
    mixins: [sidebar]
  }
</script>

<style lang="scss" scoped>

  .peer-review {
    transition: all .3s; position:relative;
    &.list-enter-active {
      transition-timing-function: ease-out;
    }
    &.list-enter {
      transform: translateX(100%); opacity:0;
    }
    &.list-enter-to {
      transform: translateX(0); opacity:1;
    }
    &.list-leave-active {
      position:absolute; width:100%; opacity:0; transition-timing-function: ease-in;
    }
    &.list-leave-to {
      transform:translateX(-100%);
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/rate.vue